import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexLayout from "@/views/layout/IndexLayout.vue";

Vue.use(VueRouter)

const routes = [
    {

        path: '/',
        component: IndexLayout,
        redirect: '/index',
        children: [
            {
                path: '/index',
                name: 'index',
                component: () => import('../views/index/Index.vue')
            },

            {
                path: '/introduce',
                name: 'introduce',
                component: () => import('@/views/news/AssociationIntroduction.vue')
            },
            {
                path: '/dangNews',
                name: 'dangNews',
                component: () => import('@/views/news/DangNews.vue')
            },
            {
                path:'/policyNews',
                name:'policyNews',
                component:()=>import('@/views/news/PolicyNews.vue')
            },
            {
                path:'/newsDetail',
                name:'newsDetail',
                component:()=>import('@/views/news/NewsDetail.vue')
            },
            {
                path:'/noticeNews',
                name:'noticeNews',
                component:()=>import('@/views/news/NoticeNews.vue')
            },
            {
                path:'/industry',
                name:'industryNews',
                component:()=>import('@/views/news/IndustryNews.vue')
            }
        ]
    },

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            // 如果存在保存的滚动位置（例如前进/后退按钮触发），恢复到该位置
            return savedPosition;
        } else {
            // 否则滚动到页面顶部
            return { x: 0, y: 0 };
        }
    },
})

export default router
